import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type SimpleConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.unity>;

export const uvIndexElementConfig: SimpleConfig = {
    legalConvertedRange: [0, null],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "uv_index",
    convertedUnits: "uv_index",
    unitCategory: "uvIndex",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 7, convertedValue: 7 },
    ],
} as const;
